import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Error } from "@bw/forms"

const Wrapper = styled.div`
  margin-bottom: 20px;
`

const Label = styled.label`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  letter-spacing: 0.025em;
  margin-bottom: 0.8em;
`

const FormField = ({ children, ...props }) => {
  return (
    <Wrapper>
      <Label htmlFor={props.name}>{props.title}</Label>
      {props.help && props.helpPosition === "above" && (
        <small>{props.help}</small>
      )}
      {children}
      {props.help && props.helpPosition === "below" && (
        <small>{props.help}</small>
      )}
      {props.name && <Error name={props.name} />}
    </Wrapper>
  )
}

FormField.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string,
  help: PropTypes.string,
  helpPosition: PropTypes.string,
}

FormField.defaultProps = {
  helpPosition: "above",
}

export { FormField }
